var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-group',{staticClass:"test-audio-control",attrs:{"label":_vm.$t(_vm.label)}},[_c('b-button',{on:{"click":function($event){_vm.$emit('input', new Date().valueOf())}}},[_c('icon',{attrs:{"name":"volume-up"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }